import { useEffect, RefObject } from 'react';

/**
 *
 * @desc Hook that detects clicks outside of a given element.
 * @param {*} elementRefs
 * @param {*} callback
 *
 */

const useClickOutside = (
  elementRefs: RefObject<HTMLElement> | HTMLElement | (HTMLElement | RefObject<HTMLElement> | null)[],
  // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
  callbackClickOutside: Function,
) => {
  useEffect(() => {
    const handleClick = (event: Event) => {
      const elRefs = Array.isArray(elementRefs) ? elementRefs : [elementRefs];

      if (!elRefs.length) {
        return;
      }

      // Checking `current` first so we can be backwards compatible with refs
      const elementRef = elRefs.find((elRef) => {
        let element = elRef;
        if (element && 'current' in element) {
          element = element.current;
        }
        return element?.contains(event.target as Node);
      });

      if (!elementRef) {
        callbackClickOutside(event);
      }
    };

    window.addEventListener('click', handleClick, true);

    return () => {
      window.removeEventListener('click', handleClick, true);
    };
  }, [elementRefs, callbackClickOutside]);
};

export default useClickOutside;
